import { notFound } from "../utils/notFoundImage";
import pluralize from "pluralize";
import { htmlDecode } from "../utils/htmlUtils";

function hideAllContainersBut(type) {
    document.querySelectorAll(`#product-section div[data-container-type]:not([data-container-type='${type}'])`).forEach(e => e.classList.toggle("d-none", true));
    document.querySelectorAll(`#product-section div[data-container-type='${type}']`).forEach(e => e.classList.toggle("d-none", false));
}

/**
 * 
 * @param {string[]} images 
 * @param {string} carouselSelector 
 */
export function generateImageCarousel(images, carouselSelector) {

    let buttons = [];
    let slides = [];

    if (images.length > 0) {
        buttons = images.map((image, index) => {
            const b = document.createElement("button");
            // <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            b.setAttribute("data-bs-target", carouselSelector);
            b.setAttribute("data-bs-slide-to", index);

            b.setAttribute("aria-label", "Image " + (index + 1));
            if (index == 0) {
                b.classList.add("active");
                b.setAttribute("aria-current", true);
            }
            return b;
        });

        slides = images.map((image, index) => {
            const d = document.createElement("div");
            d.innerHTML = `<img src="${image}" width="450" height="450" class="d-block w-100 contain" alt="Image ${index + 1}" onerror="this.src='${notFound}'; this.removeAttribute('onerror');">`;
            d.classList.add("carousel-item");
            if (index == 0) d.classList.add("active");

            return d;
        });
    } else {
        const d = document.createElement("div");
        d.innerHTML = `<img src="${notFound}" width="450" height="450" class="d-block w-100 contain" alt="No images found">`;
        d.classList.add("carousel-item");
        d.classList.add("active");

        slides.push(d);
    }

    const carousel = document.querySelector(carouselSelector);
    const carouselButtons = carousel.querySelector(".carousel-indicators");
    const carouselSlides = carousel.querySelector(".carousel-inner");

    carouselButtons.innerHTML = carouselSlides.innerHTML = "";

    carouselButtons.append(...buttons);
    carouselSlides.append(...slides);

    //document.querySelector(carouselSelector).querySelector("")
}

/**
 * 
 * @param {string} fullStr 
 * @param {number} strLen 
 * @param {string} separator 
 * @returns 
 */
export function truncateString (fullStr, strLen, separator) {
    if (fullStr.length <= strLen) return fullStr;

    separator = separator || "...";

    var sepLen = separator.length,
        charsToShow = strLen - sepLen,
        frontChars = Math.ceil(charsToShow/2),
        backChars = Math.floor(charsToShow/2);

    return fullStr.slice(0, frontChars) + 
           separator + 
           fullStr.slice(fullStr.length - backChars);
}

export {htmlDecode, pluralize};

export async function initaliseProductPage(url) {
    // hideAllContainersBut("data");

    const resp = await fetch(url);

    if (!resp.ok) {
        // TODO: Error;
        hideAllContainersBut("nodata");
        return;
    }

    const json = await resp.json();

    document.querySelectorAll("[data-product-remove-if-null]:not([data-product-remove-if-null='true'])").forEach(ele => {
        let val = json[ele.dataset.productRemoveIfNull];
        if (val == undefined && val == null) {
            ele.classList.add("d-none");
        }
    });

    document.querySelectorAll("[data-product]").forEach(ele => {
        let val = json[ele.dataset.product];
        if (val !== undefined && val !== null) {
            const attr = ele.dataset.productAttribute || null;
            const prefix = ele.dataset.productPrefix || "";

            if (typeof (val) == "boolean") val = val ? "Yes" : "No";
            else if(typeof(val) == "string") val = htmlDecode(val);

            if(ele.dataset.pluralize && ele.dataset.pluralize == "true"){
                const otherVal = json[ele.dataset.pluralizeData];
                if(otherVal !== undefined && otherVal !== null) val = pluralize(val, otherVal);
            }else if(ele.dataset.truncate){
                val = truncateString(val, ele.dataset.truncate || 8);
            }

            attr ? ele.setAttribute(attr, val) : ele.innerText = prefix + val;
        } else {
            if (ele.dataset.productRemoveIfNull) {
                ele.classList.add("d-none");
            }
        }
    });

    generateImageCarousel(json.images, "#productImageCarousel");

    hideAllContainersBut("data");
}
